export default __webpack_public_path__ + "static/media/Przepisy_Sanja.00e68d11.pdf";